import { render, staticRenderFns } from "./flight-summary.vue?vue&type=template&id=1a553649&scoped=true"
import script from "./flight-summary.vue?vue&type=script&lang=js"
export * from "./flight-summary.vue?vue&type=script&lang=js"
import style0 from "./flight-summary.vue?vue&type=style&index=0&id=1a553649&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a553649",
  null
  
)

export default component.exports